import React, { Component } from 'react';

export default class PaginaNaoEncontrada extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="master-page-pagina-nao-encontrada">
        Component content: master-page/PaginaNaoEncontrada
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/master-page/PaginaNaoEncontrada.js